module.exports = __webpack_public_path__ + "static/webapp-f1ec9f62a378d750a7c2f6c53e5d1d2e.mp4";